exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".horizontalLine{height:3px;border:0;box-shadow:inset 0 3px 3px -3px rgba(0,0,0,.5)}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaSpacer/lbaSpacer.scss"],"names":[],"mappings":"AAAA,gBACE,WAAY,AACZ,SAAU,AACV,8CAAoD,CAAE","file":"lbaSpacer.scss","sourcesContent":[".horizontalLine {\n  height: 3px;\n  border: 0;\n  box-shadow: inset 0 3px 3px -3px rgba(0, 0, 0, 0.5); }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaSpacer/lbaSpacer.scss
// module id = 430
// module chunks = 0